module.exports = __webpack_public_path__ + "static/media/infiniti-go-drive.767db14c.png";